import React from 'react';
import { componentService } from 'js/services/component.service';

export const DynamicValidatePassword = React.lazy(() => import(/* webpackChunkName: "dynamic-validate-password" */ './DynamicValidatePassword'));

componentService.registerPageComponents({ 'dynamic-validate-password': DynamicValidatePassword });
